import React, { useEffect, useState } from 'react';
import { NavBar } from '../kuroco/AppBars';
import { useNavigateWithFilters } from '../../utils/dashboardNav';
import { listDevInquiries } from '../../api/inquiriesApi';
import { devStatusOf, formatWhen } from '../../utils/inquiryView';
import '../../styles/inquiry.css';

const TABS = [
  { key: 'needs_reply', label: '返信待ち' },
  { key: 'all', label: 'すべて' },
];

/**
 * 開発者用: 全員分のお問い合わせ（/settings/help/dev）。既定は「返信待ち」（最後の発言が本人で、対応済みではない）。
 * タップで、そのやり取り（返信できる）へ。dev 以外は、サーバーが 403 で断る。
 */
export default function DevInquiryList() {
  const navigate = useNavigateWithFilters();
  const [tab, setTab] = useState('needs_reply');
  const [state, setState] = useState({ data: null, error: '' });

  useEffect(() => {
    let cancelled = false;
    setState({ data: null, error: '' });
    listDevInquiries(tab)
      .then((data) => !cancelled && setState({ data, error: '' }))
      .catch((err) => !cancelled && setState({ data: null, error: err.status === 403 ? '開発者のみ利用できます' : '一覧を読み込めませんでした' }));
    return () => {
      cancelled = true;
    };
  }, [tab]);

  const rows = state.data?.inquiries || [];
  const waiting = state.data?.needsReplyCount ?? 0;

  return (
    <div className="app">
      <NavBar title="お問い合わせ管理" backLabel="設定" backTo="/settings" hideSettings />
      <div className="scroll fade" style={{ padding: '16px 20px 32px' }}>
        <div className="inq-tabs" role="tablist">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={tab === t.key}
              className={`inq-tab${tab === t.key ? ' is-on' : ''}`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
              {t.key === 'needs_reply' && state.data && waiting > 0 && <span className="inq-tab-n">{waiting}</span>}
            </button>
          ))}
        </div>

        {state.error && <div className="inq-empty">{state.error}</div>}
        {!state.error && !state.data && <div className="inq-empty">読み込み中…</div>}
        {state.data && rows.length === 0 && (
          <div className="inq-empty">{tab === 'needs_reply' ? '返信待ちのお問い合わせはありません' : 'お問い合わせはまだありません'}</div>
        )}
        {rows.length > 0 && (
          <ul className="inq-list">
            {rows.map((r) => {
              const st = devStatusOf(r);
              return (
                <li key={r.id}>
                  <button type="button" className="inq-row" onClick={() => navigate(`/settings/help/dev/${r.id}`)}>
                    <div className="inq-row-top">
                      <span className="inq-no">{r.numberLabel}</span>
                      <span className="inq-cat">{r.category}</span>
                      <span className={`inq-status inq-status--${st.key}`}>{st.label}</span>
                    </div>
                    <div className="inq-who-line">
                      {r.author?.name || '（名前なし）'}
                      {r.author?.homeStore ? ` ／ ${r.author.homeStore}` : ''}
                    </div>
                    <div className="inq-preview">{r.preview}</div>
                    <div className="inq-when">{formatWhen(r.lastMessageAt)}</div>
                  </button>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}
